import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from './index'
import type { IClientUID } from '../clients'

export interface IStaticTraits {
    version: string
    idfVer: string
    cores: number
    model: number
    revision: number
    buildFlags: IBuildFlags
}

interface IBuildFlags {
    PARTNAME: string
    INCLUDE_SODA_UNIT: boolean
    INCLUDE_COOLING_UNIT: CoolingUnitType
    INCLUDE_AMBIENT_UNIT: boolean
    INCLUDE_CIRCULATION_PUMP_UNIT: boolean
    INCLUDE_HEATING_UNIT: boolean
    INCLUDE_BLUETOOTH: boolean
    INCLUDE_WIFI: boolean
    INCLUDE_RELSOL_1: boolean
    INCLUDE_RELSOL_2: boolean
    INCLUDE_RELSOL_3: boolean
    INCLUDE_RELSOL_4: boolean
    INCLUDE_RELSOL_5: boolean
    INCLUDE_RELSOL_6: boolean
    INCLUDE_RELSOL_7: boolean
    INCLUDE_RELSOL_8: boolean
    INCLUDE_SERIAL: boolean
    INCLUDE_KEYPAD: boolean
}

export enum CoolingUnitType {
    None = 0,
    AluminiumBlock = 1,
    IceBank = 2,
}

export async function getClientStaticTraits(clientId: IClientUID): Promise<ApiResponse<IStaticTraits>> {
    const response = await fetch(`${HOST_URL}static-traits`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<IStaticTraits>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
